import { Typography } from '@material-ui/core'
import currency from 'currency.js'
import pluralize from 'pluralize'
import React from 'react'

import CartMenuItem from './CartMenuItem'

const CartPreviousItems = ({ numberOfItems, subtotal }) => (
  <li className="cart-item">
    <div className="cart-item_summary">
      <div className="cart-item_title">{`${pluralize(
        'other item',
        numberOfItems,
        true,
      )} (In Cart)`}</div>
      <div className="cart-item_price">
        {currency(subtotal, { formatWithSymbol: true }).format()}
      </div>
    </div>
  </li>
)

const CartMenuItemList = ({
  deleteMenuItem,
  isDeletingMenuItem,
  dropoffId,
  editMenuItem,
  isEditingMenuItem,
  editable,
  isEditingPastOrder,
  menuId,
  menuItems,
  previousItems,
  previousSubtotal,
  showEditLinks,
  useFullSubTotal,
}) => (
  <ul>
    {menuItems.length > 0 ? (
      menuItems.map((menuItem, index) => (
        <CartMenuItem
          deleteMenuItem={deleteMenuItem}
          isDeletingMenuItem={isDeletingMenuItem}
          dropoffId={dropoffId}
          editable={editable}
          editMenuItem={editMenuItem}
          isEditingMenuItem={isEditingMenuItem}
          isEditingPastOrder={isEditingPastOrder}
          key={index}
          menuId={menuId}
          menuItem={menuItem}
          showEditLinks={showEditLinks}
          useFullSubTotal={useFullSubTotal}
        />
      ))
    ) : (
      <Typography>No items</Typography>
    )}
    {previousItems && previousItems.length > 0 && (
      <CartPreviousItems numberOfItems={previousItems.length} subtotal={previousSubtotal} />
    )}
  </ul>
)

CartMenuItemList.defaultProps = {
  menuItems: [],
}

export default CartMenuItemList
